import React, { Component } from "react"
import Slider from "react-slick"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Loader from "../common/loader"
import { getTeam } from "./../../services/teamService"

class OurTeam extends Component {
  constructor(props) {
    super(props)
    this.state = {
      teamItems: [],
      loading: true,
    }
  }

  async componentDidMount() {
    const { data: teamItems } = await getTeam()
    this.setState({ teamItems, loading: false })
    console.log("All Team: ", teamItems)
  }

  render() {
    const settings = {
      dots: true,
      infinite: false,
      arrows: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }

    if (this.state.loading) return <Loader />
    return (
      <Slider {...settings}>
        {this.state.teamItems.map(item => (
          <div className="pr-2 single-team" key={item.id}>
            <div className="inner">
              <div className="team-img img-fluid">
                <LazyLoadImage src={item.Image.url} alt={item.Name} />
              </div>
              <div className="team-content">
                <h4>{item.Name}</h4>
                <span className="desg">{item.Designation}</span>
                <div className="team-social">
                  <a className="fa fa-facebook" href={item.Facebook} />
                  <a className="fa fa-twitter" href={item.Twitter} />
                  <a className="fa fa-linkedin" href={item.LinkedIn} />
                  <a className="fa fa-instagram" href={item.Instagram} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    )
  }
}

export default OurTeam
